import React from 'react';
import { Loading } from '@roo/roo';
// @ts-ignore
import request from '@/utils/request';
import urlUtil, { isMenuGray } from '@/utils/url';

import './list.scss';
import ListContent from './listContent';
import FaceRecognition from './faceRecognition';

interface IState {
    openState: boolean;
    livePermission: boolean;
    initLoading: boolean;
    /** 是否已经生成过认证二维码 */
    hasAuthenticated: boolean;
}

interface IProps {
    history: any;
    editData: any;
}

class List extends React.Component<IProps, IState> {
    isStaff: boolean;

    constructor(props: IProps) {
        super(props);
        // const urlObj: any = utils.urlParse();
        this.state = {
            openState: false, // 默认没开通
            initLoading: true,
            livePermission: false, // 服务商权限
            hasAuthenticated: false,
        };
        this.isStaff = !!urlUtil.commonParams.providerRole;
    }

    initLiveRoomState = () =>
        request
            .get(
                '/api/liveRoom/state',
                {
                    busId: urlUtil.commonParams.providerId,
                    busLine: 1,
                },
                {},
                false,
            )
            .then(res => {
                // state 0:正常关闭、1:正常开启  2:违规关闭
                this.setState({
                    openState: res.data.state === 1,
                });
            })
            .catch(err => {
                const errRes = err.response;

                if (errRes.data.code === 1109) {
                    // 特殊状态码
                    this.setState({
                        hasAuthenticated: true,
                    });
                }
                this.setState({
                    openState: false,
                });
            });

    initLivePermission = () =>
        request
            .get('/api/liveRoom/permission', {
                busId: urlUtil.commonParams.providerId,
            })
            .then(res => {
                // livePermission 0没有权限，1有权限
                this.setState({
                    livePermission: res.data.livePermission === 1,
                });
            })
            .catch(() => {
                this.setState({
                    livePermission: false,
                });
            });

    componentDidMount() {
        // 首先判断权限，主账号才能访问
        if (!isMenuGray && this.isStaff) {
            return;
        }
        /**
         * 相关权限接口
         * 判断是否有直播的权限，是否可以开通直播
         */
        Promise.all([this.initLiveRoomState(), this.initLivePermission()]).then(() => {
            this.setState({
                initLoading: false,
            });
        });
    }

    closeOpenLivePage = () => {
        this.setState({
            openState: true,
        });
    };

    renderContent = () => {
        const { props, state } = this;
        if (!isMenuGray && this.isStaff) {
            // 员工没有权限
            return <div>暂无权限</div>;
        }
        if (state.initLoading) {
            // 加载中
            return null;
        }
        if (!state.livePermission) {
            // 没有直播权限
            return (
                <>
                    <p>
                        服务市场已经支持服务商开直播啦～如果想开通直播请先填问卷进行申报：
                        <a href="https://wenjuan.meituan.com/survey/5246969">点击申请</a>
                    </p>
                    <p>提交后我们的运营同学会主动联系您～</p>
                </>
            );
        }
        if (state.openState) {
            // 有权限，正常展示列表
            return <ListContent {...props} />;
        }
        // 展示实名认证页面
        return (
            <FaceRecognition
                hasAuthenticated={state.hasAuthenticated}
                {...props}
                // closeOpenLivePage={this.closeOpenLivePage}
            />
        );
    };

    render() {
        return (
            <div className="page live-list">
                {this.renderContent()}
                <Loading fullscreen backdrop visible={this.state.initLoading} lock />
            </div>
        );
    }
}

export default List;
